export enum JobStatus {
  CancelledByUser = -2,
  Error = -1,
  Pending = 0,
  Running = 1,
  Performed = 2
}

export const jobStatusMapper = {
  [JobStatus.CancelledByUser]: 'Cancelado pelo usuário',
  [JobStatus.Error]: 'Erro',
  [JobStatus.Pending]: 'Pendente',
  [JobStatus.Running]: 'Aguarde',
  [JobStatus.Performed]: 'Concluído',
}